

import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './ActivityLog.css';
import GoogleLoader from '../../../Commoncomponet/Loaders/GoogleLoader';
import { getRoleActivityLogs } from '../../../Commoncomponet/Utils';

const ActivityStatus = {
    LOADING: 'loading',
    ERROR: 'error',
    EMPTY: 'empty',
    SUCCESS: 'success',
    NOTABLE: 'Table Not Available',
};

const TimelineContent = ({ log }) => {
    const newChanges = JSON.parse(log?.new_changed_json || '{}');
    const oldData = JSON.parse(log?.old_json || '{}');

    return (
        <div className="timeline-content">
            <div className="activity-log-activity">
                <p className="activity-log-activity-creator">{log?.created_by} has </p>
                <p className="activity-log-activity-type">{log?.activity_type}</p>
                <p className="activity-log-activity-static">
                    Updated <b>({Object.keys(newChanges).join(', ')})</b>
                </p>
                {log?.updated_columns?.length > 0 && (
                    <p className="activity-log-activity-column">
                        {log.updated_columns.join(', ')}
                    </p>
                )}
            </div>
            <div className="activity-log-changes">
                <div>
                    <pre>{JSON.stringify(oldData, null, 2)}</pre>
                    <span className="arrow">→</span>
                    <pre>{JSON.stringify(newChanges, null, 2)}</pre>
                </div>
            </div>
            <p className="activity-log-date">
                at {moment.utc(log.created_at).format('hh:mm:ss A')}
            </p>
        </div>
    );
};

const StatusMessage = ({ status }) => {
    const messages = {
        [ActivityStatus.ERROR]: 'Something went wrong',
        [ActivityStatus.EMPTY]: 'Activity Not Available'
    };

    return (
        <div className="tw-h-[40dvh] tw-flex tw-justify-center tw-items-center !tw-text-3xl !tw-font-bold">
            {messages[status] || status}
        </div>
    );
};

const TimelineItem = ({ log, index, totalLogs }) => (
    <div className="timeline-item">
        <div className="timeline-icon">{totalLogs - index}</div>
        <div className="timeline-data">
            <div>
                <div className="activity-log-avatar">
                    <span>{log?.created_by[0]}</span>
                </div>
            </div>

            <TimelineContent log={log} />
        </div>
    </div>
);

const ActivityLogs = ({ id }) => {
    const [activityData, setActivityData] = useState([]);
    const [status, setStatus] = useState(ActivityStatus.LOADING);

    const groupLogsByDate = (logs) => {
        const groupByDate = logs.reduce((acc, log) => {
            const date = moment.utc(log.created_at).format('DD-MM-YYYY');
            if (!acc[date]) acc[date] = [];
            acc[date].push(log);
            return acc;
        }, {});

        return Object.entries(groupByDate).map(([date, logs]) => ({
            date,
            logs
        }));
    };

    useEffect(() => {
        const fetchActivityData = async () => {
            try {
                const response = await getRoleActivityLogs(id);
                if (response.success && response.data?.data) {
                    const groupedData = groupLogsByDate(response.data.data);
                    setActivityData(groupedData);
                    setStatus(groupedData.length ? ActivityStatus.SUCCESS : ActivityStatus.EMPTY);
                } else {
                    console.log(response?.message)
                    setStatus(response?.err?.message === 503 ? ActivityStatus.NOTABLE : ActivityStatus.ERROR);
                }
            } catch (error) {
                console.error('Error fetching activity logs:', error);
                setStatus(ActivityStatus.ERROR);
            }
        };

        fetchActivityData();
    }, [id]);

    const renderContent = () => {
        switch (status) {
            case ActivityStatus.LOADING:
                return <GoogleLoader bodyClassName="tw-h-[40dvh]" />;
            case ActivityStatus.ERROR:
            case ActivityStatus.EMPTY:
            case ActivityStatus.NOTABLE:
                return <StatusMessage status={status} />;
            default:
                return (
                    <>
                        {activityData.map((logGroup, groupIndex) => (
                            <div className="timeline" key={groupIndex}>
                                <div className="date-section">
                                    <div className="date">{logGroup.date}</div>
                                </div>
                                {logGroup.logs.map((log, index) => (
                                    <TimelineItem
                                        key={index}
                                        log={log}
                                        index={index}
                                        totalLogs={logGroup.logs.length}
                                    />
                                ))}
                            </div>
                        ))}
                    </>
                );
        }
    };

    return (
        <div className="card-body tw-px-0">
            <div className="timeline-card lg:tw-ml-6 tw-ml-4">
                {renderContent()}
            </div>
        </div>
    );
};

export default ActivityLogs;